import API_BASE from './apiBase';

/**
 * @param {string} path - e.g. `/api/collections` (API_BASE is prepended)
 * @param {RequestInit} options
 */
export async function apiFetch(path, options = {}) {
  const url = path.startsWith('http') ? path : `${API_BASE}${path.startsWith('/') ? '' : '/'}${path}`;
  const res = await fetch(url, options);
  return res;
}

export function getAdminPasswordHeaders() {
  try {
    const pwd = sessionStorage.getItem('jet_admin_api_password');
    if (!pwd) return {};
    return { 'x-admin-password': pwd };
  } catch {
    return {};
  }
}

/**
 * Prompt once per browser session; stores in sessionStorage.
 * @returns {string|null} password or null if cancelled / empty
 */
export function ensureAdminApiPassword(promptText = 'Enter admin password:') {
  try {
    let pwd = sessionStorage.getItem('jet_admin_api_password');
    if (pwd) return pwd;
    pwd = window.prompt(promptText);
    if (pwd == null) return null;
    const trimmed = pwd.trim();
    if (!trimmed) return null;
    sessionStorage.setItem('jet_admin_api_password', trimmed);
    return trimmed;
  } catch {
    return null;
  }
}

export function clearAdminApiPassword() {
  try {
    sessionStorage.removeItem('jet_admin_api_password');
  } catch { /* ignore */ }
}
